export const GET_ACTIVE_FEATURED_OCCASIONS_DATA = '[OCCASIONS] GET_FEATURED_OCCASIONS_DATA';
export const GET_INACTIVE_FEATURED_OCCASIONS_DATA =
  '[OCCASIONS] GET_INACTIVE_FEATURED_OCCASIONS_DATA';
